/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CarpsaleManagementCreateItemRequest = {
    categoryId: number;
    subCategoryId?: number;
    code: string;
    type: CarpsaleManagementCreateItemRequest.type;
    language: CarpsaleManagementCreateItemRequest.language;
    name: string;
    nameEn?: string;
    nameCn?: string;
    optioNames?: string;
    optioNamesEn?: string;
    optioNamesCn?: string;
    company?: string;
    companyEn?: string;
    companyCn?: string;
    kind?: string;
    kindEn?: string;
    kindCn?: string;
    sex: CarpsaleManagementCreateItemRequest.sex;
    isPrice: boolean;
    price?: number;
    salePrice?: number;
    isQuantity: boolean;
    quantity?: number;
    size?: number;
    sendType: CarpsaleManagementCreateItemRequest.sendType;
    context?: string;
    contextEn?: string;
    contextCn?: string;
    startSaleDatetime?: string;
    openStatus: CarpsaleManagementCreateItemRequest.openStatus;
    releaseSetting?: CarpsaleManagementCreateItemRequest.releaseSetting;
    postDate?: string;
    saleId?: number;
    saleCode?: string;
    startDate?: string;
    endDate?: string;
};

export namespace CarpsaleManagementCreateItemRequest {

    export enum type {
        CONSUMER = 'consumer',
        BUSINESS = 'business',
        BOTH = 'both',
    }

    export enum language {
        JAPANESE = 'japanese',
        FOREIGN = 'foreign',
        ALL = 'all',
        NOT = 'not',
    }

    export enum sex {
        MALE = 'male',
        FEMALE = 'female',
        UNKNOWN = 'unknown',
        FEMALE_NOW = 'female_now',
    }

    export enum sendType {
        SINGLE = 'Single',
        MULTI = 'Multi',
    }

    export enum openStatus {
        HOLD = 'hold',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

